import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../common/components/form/form.module'



export default function TrainerInfoComponent({ handleInnerFormChange, selectedTrainers,  }: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>



            <InputContainer
              label="Trainer Login Verified"
              name="IsTrainerLoginVerified"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'TrainerInfo.IsTrainerLoginVerified',
                  selectedTrainers?.VentureInfo
                )
              }}
              type="checkbox"
              value={selectedTrainers?.VentureInfo?.IsTrainerLoginVerified}
            />

        
            <InputContainer
              label="Remarks"
              name="Remarks"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TrainerInfo.Remarks',
                  selectedTrainers?.VentureInfo
                )
              }}
              type="text"
              value={selectedTrainers?.VentureInfo?.Remarks}
            />

            






          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Venture Info"
      />

    </>
  )
}